import {
  Checkbox as CCheckbox,
  type CheckboxProps as CCheckboxProps,
  FormControl,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";
import { forwardRef } from "react";

export interface CheckboxProps extends CCheckboxProps {
  helperText?: string;
  error?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ helperText, error, isInvalid, isRequired, isDisabled, children, ...rest }, ref) => (
    <FormControl isInvalid={isInvalid} isRequired={isRequired} isDisabled={isDisabled}>
      <CCheckbox ref={ref} {...rest}>
        {children}
      </CCheckbox>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  ),
);
